import TableRow, { tableRowClasses } from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

// スタイルの上書きがsx記法で実現できなかったため、styledを利用
export const CVTableRow = styled(TableRow)(({ theme }) => ({
  [`&.${tableRowClasses.hover}:hover`]: {
    backgroundColor: theme.palette.secondary.light,
  },
}));
